var _linearGradient, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyGamesFavoriteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 57 57",
    xmlSpace: "preserve"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__b_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -272.14,
    y1: 418.561,
    x2: -271.64,
    y2: 418.061,
    gradientTransform: "matrix(57 0 0 -57 15512 23858)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7b500"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__b",
    d: "M5 0h52L0 57V5c0-2.8 2.2-5 5-5z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#prefix__b_2_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__b_1_",
    d: "M5 0h52L0 57V5c0-2.8 2.2-5 5-5z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fillOpacity: 0.82
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 25c-.1 0-.2 0-.3-.1l-1.3-1.2c-4.7-4-8.4-7.4-8.4-11.2C8 9.4 10.5 7 13.7 7 15.9 7 17 8 18 9.1 19 8 20.1 7 22.3 7c3.2 0 5.7 2.4 5.7 5.5 0 3.8-3.6 7.2-8.4 11.2l-1.3 1.2c-.1.1-.2.1-.3.1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f7b500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.2c.1 0 .1 0 .1-.1 0 0 .5-1.4.7-2.2 0-.1.3-.1.3 0l.7 2.2c0 .1.1.1.1.1h2.4c.2 0 .2.2.1.3l-1.9 1.4-.1.1.7 2.2c.1.1-.1.3-.3.2L18.1 17h-.2L16 18.4c-.1.1-.3 0-.3-.2l.7-2.2s0-.1-.1-.1l-1.9-1.4c-.1-.1-.1-.3.1-.3H17z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  })));
}
SvgMyGamesFavoriteIcon.displayName = 'MyGamesFavoriteIcon';
export default SvgMyGamesFavoriteIcon;